export default __webpack_public_path__ + "static/media/planning1.bbc83c80.jpg";